<template>
    <div id="notModal" class="notification a-dropdown-item">
        <button  type="button" class="close" @click="closemodal">
            <span aria-hidden="true">&times;</span>
        </button>
        <!-- head -->
        <div style="background: rgb(240,240,240);">
            <h2 class="titNot a-dropdown-item"> {{language === 'English'?'Notifications':'Notificaciones'}}</h2>
        </div>
        <!-- Cuerpo -->
        <div class="bodyNot a-dropdown-item">
            <label v-if="notificationsdata.length<=0" style="margin-left:10px">{{language==='English'?'no notifications':'No hay notificaciones'}}</label>
            <div v-for="notifications in notificationsdata" :key="notifications.length" @click="gonotificationlink(notifications.username,notifications.name,notifications._id_proyect===undefined?null:notifications._id_proyect,notifications._id_post===undefined?null:notifications._id_post)"  role="alert" class="msNot form-row a-dropdown-item">
                <div class="col-3 a-dropdown-item" style="top: 10px;">
                    <div class="imagNotCont" >
                        <img :src="notifications.photo" alt="foto"  height="40">
                    </div>
                </div>
                <div class="col-8 a-dropdown-item" style="text-align: left;">
                    <p class="textMsNot a-dropdown-item">{{notifications.description}}</p>
                    <label>{{notifications.Datetoday}}</label>
                    <!--p class="a-dropdown-item" style="color:rgb(180,180,180);font-size:13px;" >Hace 10 minutos</p -->
                </div>
                <!--div  class="col-1 a-dropdown-item" style="top: 20px;">
                    <i  class="fas fa-paper-plane a-dropdown-item"></i>
                </div-->
            </div>
        </div>
    </div> 
</template>
<script>
import moment from 'moment'
import env from '../../../config/env.example'
import {NotificationsService} from "@/services"


import {EventBus} from '@/helpers/eventbus/event-bus'
export default {
    data(){
        return{
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            notificationsdata:[],
            session:false
        }
    },
    sockets:{
        getnotificationscomment(data){
            if(data){
                let id = JSON.parse(localStorage.getItem('iden'))._id
                if(data.name === 'Comment'){
                    if(this.$route.name !=='Comentarios' && data._id_user_sended ===id){
                        data.visible = false
                        //console.log(data)
                        let Datetoday = moment(data.created_at).fromNow()
                        data.Datetoday = Datetoday
                        let descriptionnotification = this.language ==='English' ? `User ${data.description.split(',')[1]}
                            commented on your project ${data.description.split(',')[0]}
                        `:`El usuario ${data.description.split(',')[1]} comentó en tu proyecto ${data.description.split(',')[0]}`
                        data.description = descriptionnotification
                        this.notificationsdata.unshift(data)
                        this.notificationsdata = this.notificationsdata.slice(0, 20)
                        //console.log(checked)
                        let datanovisible = this.notificationsdata.filter(element=>element.visible === false).length
                        EventBus.$emit('senddatanovisible',(datanovisible))
                    }
                }else if(data.name ==='Like Post'){
                    if(data._id_user_sended ===id){
                        data.visible = false
                        //console.log(data)
                        let Datetoday = moment(data.created_at).fromNow()
                        data.Datetoday = Datetoday
                        let descriptionnotification = this.language ==='English' ? `User ${data.description}
                        likes one of your posts`:`El usuario ${data.description} le gusta una de tus publicaciones`
                        data.description = descriptionnotification
                        this.notificationsdata.unshift(data)
                        this.notificationsdata = this.notificationsdata.slice(0, 20)
                        //console.log(checked)
                        let datanovisible = this.notificationsdata.filter(element=>element.visible === false).length
                        EventBus.$emit('senddatanovisible',(datanovisible))
                    }
                }else if(data.name === 'Comment Post'){
                    if(data._id_user_sended ===id){
                        data.visible = false
                        //console.log(data)
                        let Datetoday = moment(data.created_at).fromNow()
                        data.Datetoday = Datetoday
                        let descriptionnotification = this.language ==='English' ? `User ${data.description}
                        commented in one of your posts.`:`El usuario ${data.description} comentó en una de tus publicaciones`
                        data.description = descriptionnotification
                        this.notificationsdata.unshift(data)
                        this.notificationsdata = this.notificationsdata.slice(0, 20)
                        //console.log(checked)
                        let datanovisible = this.notificationsdata.filter(element=>element.visible === false).length
                        EventBus.$emit('senddatanovisible',(datanovisible))
                    }
                }else if(data.name === 'Report Post'){
                    if(data._id_user_sended ===id){
                        data.visible = false
                        //console.log(data)
                        let Datetoday = moment(data.created_at).fromNow()
                        data.Datetoday = Datetoday
                        let descriptionnotification = this.language ==='English' ? `One of your posts has been reported, please don't make posts that make others uncomfortable.`:`Una de tus publicaciones ha sido reportado, por favor no vuelva a hacer publicaciones que incomoden a otros.`
                        data.description = descriptionnotification
                        this.notificationsdata.unshift(data)
                        this.notificationsdata = this.notificationsdata.slice(0, 20)
                        //console.log(checked)
                        let datanovisible = this.notificationsdata.filter(element=>element.visible === false).length
                        EventBus.$emit('senddatanovisible',(datanovisible))
                    }
                }
            }
        },
        getnotifications(data){
            if(this.session){
                if(data.existfollowers){
                    //console.log(data)
                    this.getnotifications(true)
                }
            }
        },
    },
    mounted(){  
        this.getusersession()
        this.getnotifications(false)
        if(this.language === 'English'){
            moment.locale('us')
        }else{
            moment.locale('es')
        }
        EventBus.$on('elementvisible',()=>{
            this.notificationsdata.forEach(element=>{
                element.visible=true
            })
        })
       
    },
    methods:{
        getusersession(){
            let userdata = JSON.parse(localStorage.getItem('user'))
            if(userdata){
                this.session = true
            }
        },
        gonotificationlink(username,namenotification,idproject,idpost){
            if(namenotification === 'Create Project'){
                window.location = `${env.host}${username}`
            }else if(namenotification === 'Comment'){
                this.$router.push('/comments/'+idproject)
            }else if(namenotification === 'Like Post'){
                this.$router.push({path:'/post/publications',query:{idpost:idpost}})
                EventBus.$emit('getpostid',(namenotification))
            }else if(namenotification === 'Comment Post'){
                this.$router.push({path:'/post/publications',query:{idpost:idpost}})
                EventBus.$emit('getpostid',(namenotification))
            }else if(namenotification === 'Report Post'){
                this.$router.push({path:'/post/publications',query:{idpost:idpost}})
                EventBus.$emit('getpostid',(namenotification))
            }else{
                 window.location = `${env.host}post/publications`
            }

        },
        closemodal(){
            var box = document.getElementById('notModal');
            box.style.display="none"
        },
        async getnotifications(sendednow){
            try{
                let data = {
                    
                }
                let res = await NotificationsService.list(data)
                if(res.data.notifications.length>0){
                    res.data.notifications.forEach(notifications => {
                        //console.log(moment(notifications.created_at).fromNow())
                        let Datetoday = moment(notifications.created_at).fromNow()
                        notifications.Datetoday = Datetoday
                        let descriptionnotification 
                        notifications.username = notifications.description.split(',')[1]
                        if(notifications.name ==='Create Project'){
                            descriptionnotification = this.language ==='English' ? `User ${notifications.description.split(',')[1]}
                                created the project ${notifications.description.split(',')[0]}
                            `:`El usuario ${notifications.description.split(',')[1]} creó el proyecto ${notifications.description.split(',')[0]}`
                            if(sendednow){
                                if(notifications.Datetoday === 'hace unos segundos' || notifications.Datetoday === 'a few seconds ago'){
                                    notifications.visible = false
                                }
                            }
                            notifications.description = descriptionnotification
                        }else if(notifications.name ==='Comment'){
                            descriptionnotification = this.language ==='English' ? `User ${notifications.description.split(',')[1]}
                                commented on your project ${notifications.description.split(',')[0]}
                            `:`El usuario ${notifications.description.split(',')[1]} comentó en tu proyecto ${notifications.description.split(',')[0]}`
                            notifications.description = descriptionnotification
                        }else if(notifications.name === 'Save Post'){
                            descriptionnotification = this.language ==='English' ? `User ${notifications.description}
                                made a post for his followers.`:`El usuario ${notifications.description} hizo una publicación para sus seguidores.`
                            if(sendednow){
                                if(notifications.Datetoday === 'hace unos segundos' || notifications.Datetoday === 'a few seconds ago'){
                                    notifications.visible = false
                                }
                            }
                            notifications.description = descriptionnotification
                        }else if(notifications.name === 'Comment Post'){
                            descriptionnotification = this.language ==='English' ? `User ${notifications.description}
                            commented in one of your posts.`:`El usuario ${notifications.description} comentó en una de tus publicaciones`
                            notifications.description = descriptionnotification
                        }else if(notifications.name === 'Like Post'){
                            descriptionnotification = this.language ==='English' ? `User ${notifications.description}
                            likes one of your posts`:`El usuario ${notifications.description} le gusta una de tus publicaciones`
                            notifications.description = descriptionnotification
                        }else if(notifications.name === 'Report Post'){
                            descriptionnotification = this.language ==='English' ? `One of your posts has been reported, please don't make posts that make others uncomfortable.`:`Una de tus publicaciones ha sido reportado, por favor no vuelva a hacer publicaciones que incomoden a otros.`
                            notifications.description = descriptionnotification
                        }
                        
                    })
                    this.notificationsdata = res.data.notifications
                    let datanovisible = this.notificationsdata.filter(element=>element.visible === false).length
                    if(sendednow){
                        EventBus.$emit('senddatanovisible',(datanovisible))
                    }
                }
            }catch(err){
                console.log(err)
            }
            
        }
    }

}
</script>
<style scoped>
    .notification{
        background:white;
        z-index:10000;
        width: 400px; 
        height: auto;
        display: none;
        position: fixed; 
        color:black;
        right: 0.4%;
        border: 1px solid rgb(240,240,240);
        
    }
    .titNot{
        padding: 12px;
        font-family: sans-serif; 
        font-size:17px; 
        font-weight: 400;
        margin-bottom: 0;
    }
    .bodyNot{
        height: 500px; 
        overflow-y: auto; 
        overflow-x: hidden; 
        max-width: 100%;
        margin: 0;
        padding: 0;
        padding-bottom:80px
    }
    .msNot{
        text-align: center;
        padding: 10px;
        margin-bottom: 0;
        min-height: 60px;
    }
    .msNot:hover{
        background: rgba(241,241,241,.5);
        cursor: pointer;
    }
    .imagNotCont{
        position: relative;
        height: 50px; 
        overflow: hidden;
        width: 50px; 
        border-radius: 50%;
        margin: auto;
    }
    .msNot img{        
        width: 50px;
        padding: 0;
        margin: 0;
    }
    .textMsNot{
        margin-bottom: 0;
        font-size: 14px;
        line-height: 16px;
        padding-bottom: 5px;
    }
    .footNot{
        font-family: sans-serif; 
        font-size: 13px;
        padding: 5px; 
        margin: 0;
    }

    @media (max-width: 600px) {
        .notification{
            width: 250px;
            right: -1px;
        }
    }

</style>